import { Routes, Route } from "react-router-dom";
import Contact from "./screens/Contact";
import Home from "./screens/Home";
import NepalForm from "./screens/NepalForm";
import NepalFormInternal from "./screens/NepalFormInteral";
import BookMyShow from "./screens/BookMyShow";
import InternalCounsellorForm from "./screens/InteralForm";
import StudentForm from "./screens/Form";
import EventAttendedForm from "./screens/FniForm";
import UniversityLinkedStudent from "./screens/UniversityLinkedStudent";
import LinksAll from "./screens/Links";
import BrandLift from "./screens/BrandLift";
import BrandLift2 from "./screens/BrandLift2";
import GuestVideo from "./screens/GuestVideo";
import MusicForm from "./screens/MusicForm";

export default function NavigateRoute() {
  return (
    <Routes>
      {/* <Route path="/" element={<Home />} /> */}
      <Route path="/" element={<LinksAll />} />

      <Route path="/f/:eventId" element={<Contact />} />
      <Route path="/fn/:eventId" element={<NepalForm />} />
      {/* <Route path="/fni/:eventId" element={<NepalFormInternal />} UniversityLinkedStudent /> */}
      <Route path="/fni/:eventId" element={<EventAttendedForm />} />
      <Route path="/form" element={<StudentForm />} />
      <Route
        path="/internal/form/:eventId"
        element={<InternalCounsellorForm />}
      />
      <Route
        path="/university-linked-student/:eventId"
        element={<UniversityLinkedStudent />}
      />
      <Route path="/all-links" element={<LinksAll />} />
      <Route path="/BrandLift/:eventId" element={<BrandLift />} />
      <Route path="/Guest/Portal/Video" element={<GuestVideo />} />
      <Route path="/BrandLiftoworld/:eventId" element={<BrandLift2 />} />
      <Route path="/bms/:eventId" element={<BookMyShow />} />
      <Route path="/music/:eventId" element={<MusicForm />} />
    </Routes>
  );
}
